import React from 'react';

const Icon85OrientationBumperChaiseRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M544.51 174.1L544.51 206.77L284.69 206.77C279.62 206.77 275.51 202.66 275.51 197.59L275.51 174.1C275.51 169.03 279.62 164.92 284.69 164.92L535.33 164.92C540.4 164.92 544.51 169.03 544.51 174.1Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinejoin="round"
    />
    <path
      d="M544.51 215.77L544.51 423.52L544.51 477.42C544.51 482.39 540.48 486.42 535.51 486.42L492.26 486.42L492.26 423.52L492.26 206.77L535.51 206.77C540.48 206.77 544.51 210.8 544.51 215.77Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinejoin="round"
    />
    <path
      d="M483.26 635.08L284.51 635.08C279.54 635.08 275.51 631.05 275.51 626.08L275.51 206.77L492.26 206.77L492.26 626.07C492.26 631.04 488.23 635.07 483.26 635.07L483.26 635.08Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon85OrientationBumperChaiseRight;
